import React, { useEffect, useState } from 'react'
import { isEmpty } from 'lodash'

import KanbanFiltersContext from 'contexts/KanbanFiltersContext'

import useFilter from 'hooks/useFilter'
import useSearch from 'hooks/useSearch'

import constants from 'constants/index'
import * as service from 'service'

const KanbanFiltersProvider = ({ children }) => {
  const { VIEW_MODE_KANBAN } = constants.activities

  const filter = useFilter()
  const { searchInput, handleSearchValue, isSearching } = useSearch(() => {},
  500)

  const [users, setUsers] = useState([])
  const [onlyMine, setOnlyMine] = useState(false)
  const [viewMode, setViewMode] = useState(VIEW_MODE_KANBAN)
  const [unlinkedOnly, setUnlinkedOnly] = useState(false)
  const [sourceRemovedOnly, setSourceRemovedOnly] = useState(false)

  useEffect(() => {
    const load = async () => {
      if (!filter.drawerOpen || !isEmpty(users)) return
      try {
        const res = await service.dponet.users.get({
          minimal: true,
          perPage: 9999,
        })
        setUsers(res?.data?.users || [])
      } catch {
        // silently ignore
      }
    }
    load()
    //eslint-disable-next-line
  }, [filter.drawerOpen])

  return (
    <KanbanFiltersContext.Provider
      value={{
        filter,
        searchInput,
        handleSearchValue,
        isSearching,
        onlyMine,
        setOnlyMine,
        unlinkedOnly,
        setUnlinkedOnly,
        sourceRemovedOnly,
        setSourceRemovedOnly,
        viewMode,
        setViewMode,
        users,
      }}
    >
      {children}
    </KanbanFiltersContext.Provider>
  )
}

export default KanbanFiltersProvider
